import React from 'react';
import { FaCheck } from 'react-icons/fa';

const StepIndicator = ({ steps, currentStep }) => (
  <div className="flex items-center justify-between mb-8">
    {steps.map((step, index) => (
      <React.Fragment key={index}>
        <div className={`flex flex-col items-center ${index <= currentStep ? 'text-blue-600' : 'text-gray-400'}`}>
          <div className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 flex items-center justify-center ${
            index < currentStep ? 'bg-green-500 border-green-500' : 
            index === currentStep ? 'border-blue-600' : 'border-gray-300'
          }`}>
            {index < currentStep ? (
              <FaCheck className="text-white" />
            ) : (
              <span className={index === currentStep ? 'text-blue-600' : 'text-gray-500'}>{index + 1}</span>
            )}
          </div>
          <p className="text-xs mt-2 hidden md:block">{step.label}</p>
        </div>
        {index < steps.length - 1 && (
          <div className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
            index < currentStep ? 'border-green-500' : 'border-gray-300'
          }`}></div>
        )}
      </React.Fragment>
    ))}
  </div>
);

export default StepIndicator;